var _slicedToArray = require("/builds/hypercite/vanilla-frontend/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.classd = {}));
})(this, function (exports) {
  'use strict';
  /*!
    Copyright (c) 2019 Ganesh Prasad.
    Licensed under the MIT License (MIT), see
    https://github.com/GnsP/classd
  */

  /**
   *  Safely call functions without any arguments
   *  @param {function} fn - any function, should return a string
   */

  function safecall(fn) {
    try {
      return fn.call(null).toString();
    } catch (err) {
      return '';
    }
  }
  /**
   * Convert the argument to a space separated list of classnames
   * - ignore falsy values (exception 0) and booleans
   * - flatten and concat arrays, lists, sets and other iterables
   * - recursively apply itself on elements of iterables
   * - in case of plain objects and Maps, ignore keys with falsy values
   * - in case of function, safecall it and return the result as string
   *
   * @param {*} value
   * @return {string} space separated list of names
   */


  function names(value) {
    var res = '';
    var hasOwn = {}.hasOwnProperty;
    if (typeof value === 'string') return value;else if (value === null || value === undefined || typeof value === 'boolean' || typeof value === 'number' && isNaN(value)) return '';else if (typeof value === 'function') return safecall(value);else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          res += ' ' + names.call(null, value[i]);
        }

        return res;
      } else if (value instanceof Map) {
        var _iterator = _createForOfIteratorHelper(value),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                _key = _step$value[0],
                val = _step$value[1];

            if (!!val) res += ' ' + _key;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return res;
      } else if (typeof value[Symbol.iterator] === 'function') {
        var _iterator2 = _createForOfIteratorHelper(value),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _val = _step2.value;
            res += ' ' + names.call(null, _val);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return res;
      } else {
        for (var key in value) {
          if (hasOwn.call(value, key) && value[key]) res += ' ' + key;
        }

        return res;
      }
    } else return value.toString();
  }
  /**
   *  Trim whitespace from both ends of the string and replace all remaining whitespaces with single spaces
   *  @param {string} str
   *  @return {string} string with whitespaces trimmed
   */


  function trim(str) {
    var res = '',
        prev = true,
        ch = '';

    for (var i = 0; i < str.length; i++) {
      ch = str.charAt(i);

      if (ch === ' ' || ch === '\t' || ch === '\n' || ch === '\r' || ch === '\v') {
        if (!prev) prev = true;
      } else {
        if (res && prev) res += ' ';
        res += ch;
        prev = false;
      }
    }

    return res;
  }
  /*!
    Copyright (c) 2019 Ganesh Prasad.
    Licensed under the MIT License (MIT), see
    https://github.com/GnsP/classd
  */

  /**
   * Take a template literal and convert it to a valid classnames string
   * @param {string[]} strings
   * @param {*[]} values
   * @return {string} valid classnames string
   */


  function classd(strings) {
    var res = '';

    for (var i = 0; i < strings.length; i++) {
      res += strings[i];
      res += names.call(null, i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]);
    }

    return trim.call(null, res);
  }
  /**
   * Take a template literal and convert it to a deduped classnames string
   * @param {string[]} strings
   * @param {*[]} values
   * @return {string} valid classnames string (deduped)
   */


  function classDedupe(strings) {
    var cache = new Set(),
        res = '',
        space = false;

    for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
      values[_key2 - 1] = arguments[_key2];
    }

    var classes = classd.apply(void 0, [strings].concat(values)).split(' ');

    for (var i = 0; i < classes.length; i++) {
      if (!cache.has(classes[i])) {
        if (space) res += ' ';
        res += classes[i];
        cache.add(classes[i]);
        space = true;
      }
    }

    return res;
  }
  /*!
    Copyright (c) 2019 Ganesh Prasad.
    Licensed under the MIT License (MIT), see
    https://github.com/GnsP/classd
  */

  /**
   * Combine arguments to a valid classnames string
   * @param {...*} values
   * @return {string} valid classnames string
   */


  function classdFn() {
    var res = '';

    for (var i = 0; i < arguments.length; i++) {
      res += names.call(null, i < 0 || arguments.length <= i ? undefined : arguments[i]) + ' ';
    }

    return trim.call(null, res);
  }
  /**
   * Combine arguments to a deduped classnames string
   * @param {...*} values
   * @return {string} deduped classnames string
   */


  function classDedupeFn() {
    var res = '',
        space = false,
        cache = new Set();
    var classes = classdFn.apply(void 0, arguments).split(' ');

    for (var i = 0; i < classes.length; i++) {
      if (!cache.has(classes[i])) {
        if (space) res += ' ';
        res += classes[i];
        cache.add(classes[i]);
        space = true;
      }
    }

    return res;
  }
  /*!
    Copyright (c) 2019 Ganesh Prasad.
    Licensed under the MIT License (MIT), see
    https://github.com/GnsP/classd
  */


  exports.classDedupe = classDedupe;
  exports.classDedupeFn = classDedupeFn;
  exports.classd = classd;
  exports.classdFn = classdFn;
  exports.default = classd;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});